export const reportActionConstants = {
  UPDATE_REPORTS_LIST: 'UPDATE_REPORTS_LIST',
  SET_REPORT_OPTIONS: 'SET_REPORT_OPTIONS',
  ADD_ASSET_TO_REPORT: 'ADD_ASSET_TO_REPORT',
  SET_ASSET_OVERVIEW_AVAILABLE: 'SET_ASSET_OVERVIEW_AVAILABLE',
  CLEAR_ASSET_OVERVIEW_AVAILABLE: 'CLEAR_ASSET_OVERVIEW_AVAILABLE',
  REMOVE_ASSET_FROM_REPORT: 'REMOVE_ASSET_FROM_REPORT',
  SELECT_ASSET_FOR_CHARTS: 'SELECT_ASSET_FOR_CHARTS',
  ADD_CHART_TO_REPORT: 'ADD_CHART_TO_REPORT',
  ADD_CHART_IMAGE_TO_REPORT: 'ADD_CHART_IMAGE_TO_REPORT',
  REMOVE_CHART_FROM_REPORT: 'REMOVE_CHART_FROM_REPORT',
  ADD_ALL_SENSORS: 'ADD_ALL_SENSORS',
  REMOVE_ALL_SENSORS: 'REMOVE_ALL_SENSORS',
  INIT_REPORTS: 'INIT_REPORTS',
  SET_SUBMITTING_REPORT: 'SET_SUBMITTING_REPORT',
  CLEAR_SUBMITTING_REPORT: 'CLEAR_SUBMITTING_REPORT',
  SET_CAPTURING_CHARTS: 'SET_CAPTURING_CHARTS',
  CLEAR_CAPTURING_CHARTS: 'CLEAR_CAPTURING_CHARTS',
  SET_CHARTS_ASSETS_SORTER: 'SET_CHARTS_ASSETS_SORTER',
  SET_REPORTS_SORTER: 'SET_REPORTS_SORTER',
  ADD_TASKS_TO_REPORT: 'ADD_TASKS_TO_REPORT',
  ADD_ALL_TASKS_TO_REPORT: 'ADD_ALL_TASKS_TO_REPORT'
};

export const reportOptionConstants = {
  PLANT_HEALTH_HEADING: 'Plant Health Summary',
  PLANT_HEALTH_SUBHEADING: 'Charts and graphs of overall plant health',
  ASSET_HEALTH_HEADING: 'Asset Health Summary',
  ASSET_HEALTH_SUBHEADING: 'A tabular summary of all selected assets',
  INDEPTH_ANALYSIS_HEADING: 'In-depth Asset Analysis',
  INDEPTH_ANALYSIS_SUBHEADING: 'Asset condition, health metrics, selected charts, and linked task when present',
  CHARTS_HEADING: 'Charts',
  ALL_DEVICES: 'Include All Devices',
  ALL_DEVICES_SUBHEADING: 'Include All Devices in the site, both reachable and unreachable',
  CHARTS_SUBHEADING: 'Selected charts such as trend, spectrum or waveform for each asset',
  DEVICE_HEALTH_HEADING: 'Device Health Summary',
  DEVICE_HEALTH_SUBHEADING: 'Summarized views of each device health such as unreachable or low battery devices',
  ASSET_TASK_HEADING: 'Asset Task Summary',
  ASSET_TASK_SUBHEADING: 'A summary of tasks for each asset',
  ASSET_MAINTENANCE_TASK_HEADING: 'Asset Maintenance Task Summary',
  ASSET_MAINTENANCE_TASK_SUBHEADING: 'Maintenance tasks for each asset',
  INSTRUMENTATION_TASK_HEADING: 'Instrumentation Task Summary',
  INSTRUMENTATION_TASK_SUBHEADING: 'Instrumentation tasks for sensors on each asset',
  ASSETS_MISSING_DETAILS_HEADING: 'Assets Missing Details',
  ASSETS_MISSING_DETAILS_SUBHEADING: 'List of assets with incomplete setup',
  MISSING_INFO_HEADING: 'Info',
  MISSING_INFO_SUBHEADING: 'Component properties such as speed, pole count, etc.',
  MISSING_CHARTS_HEADING: 'Charts (Alarm Thresholds)',
  MISSING_CHARTS_SUBHEADING: 'Tags missing alarm threshold configuration',
  MISSING_HEALTH_HEADING: 'Health (Baseline)',
  MISSING_HEALTH_SUBHEADING: 'Components missing baseline setup',
  ALARM_LIMITS_HEADING: 'Alarm Limits Report',
  ALARM_LIMITS_SUBHEADING: 'Per-asset table of tags with missing alarm thresholds',
  ALARM_TEMPERATURE_HEADING: 'Temperature',
  ALARM_TEMPERATURE_SUBHEADING: 'Temperature warning and critical thresholds',
  ALARM_VIB_VELOCITY_HEADING: 'Vibration Velocity',
  ALARM_VIB_VELOCITY_SUBHEADING: 'Vibration velocity warning and critical thresholds',
  ALARM_VIB_ACCELERATION_HEADING: 'Vibration Acceleration',
  ALARM_VIB_ACCELERATION_SUBHEADING: 'Vibration acceleration warning and critical thresholds',
  ALARM_VIB_DEMOD_HEADING: 'Vibration Demod',
  ALARM_VIB_DEMOD_SUBHEADING: 'Vibration demod warning and critical thresholds',
};

export const reportDocxConstants = {
  REPORT_TITLE: 'Condition Monitoring Report',
  PLANT_HEALTH_HEADING: 'Plant Health Summary',
  ASSET_HEALTH_HEADING: 'Asset Health Summary',
  INDEPTH_ANALYSIS_HEADING: 'Asset Details',
  DEVICE_HEALTH_HEADING: 'Device Health Summary',
  ASSET_TASK_SUMMARY_HEADING: 'Asset Task Summary',
  ASSET_MAINTENANCE_TASK_HEADING: 'Asset Maintenance Tasks',
  INSTRUMENTATION_TASK_HEADING: 'Instrumentation Tasks',
};
